import { render } from "./failed-logins.vue?vue&type=template&id=611510b4"
import script from "./failed-logins.vue?vue&type=script&lang=js"
export * from "./failed-logins.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__